import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

import { translate } from "./utils";

import Alert from "./components/Alert";

import Home from "./pages/Clasificatorio/Home";
import Receipt from "./pages/Clasificatorio/Receipt";

/*
  Stripe.setPublishableKey('pk_test_3ctgdNDZHsLr2cbkOHmZfxCz'); // test publishable key
  Stripe.setPublishableKey('pk_live_pzRQTFEdAFpsr4KFrAe7kbAK'); // live publishable key
*/
const stripePromise = loadStripe("pk_live_pzRQTFEdAFpsr4KFrAe7kbAK");

const Clasificatorio = ({ lang, closed = false }) => {
	const [id, setId] = useState("");
	const [status, setStatus] = useState(closed ? 3 : 2);

	/*
    0 - error
    1 - registration & payment submitted successfully
    2 - not yet started
    3 - closed
  */

	const handleStatus = (id = "", status) => {
		setId(id);
		setStatus(status);
	};

	return (
		<>
			{status === 3 ? (
				<Alert
					data={{
						type: "error",
						text: translate(
							lang,
							"Clasificatorio Mexicano registration is now closed.",
							"El registro para el Clasificatorio Mexicano ha concluido."
						),
					}}
				/>
			) : id && status === 1 ? (
				<Receipt id={id} lang={lang} />
			) : (
				<Home status={handleStatus} stripePromise={stripePromise} lang={lang} />
			)}
		</>
	);
};

export default Clasificatorio;
